import {connect} from 'react-redux';
import {size} from 'lodash';
import {createStructuredSelector} from 'reselect';

import {getOrderReportLevel} from '/component/partial/report/OrdersReportDataRenderer/OrdersReportListItem.util';
import {pageSize} from '/constant/data.constant';
import {
  PAGE_NUMBER_FIELD_NAME,
  PAGE_SIZE_FIELD_NAME,
} from '/enum/apiFields.enum';
import {allOrders} from '/redux/action/report.action';
import {
  hasReportData,
  reportData,
  reportIsLoadingStateValue,
  reportMeta,
} from '/redux/selector/report.selector';
import {calculatePageNumber} from '/util/requestParams.util';

import OrdersReportDataRenderer from './OrdersReportDataRenderer';

export default connect(
  createStructuredSelector({
    reportIsLoading: reportIsLoadingStateValue,
    hasReportData,
    reportData,
    reportMeta,
  }),
  dispatch => ({
    fetchReport: ({
      reportName,
      reportParams,
      appendData,
      level,
      products,
      accountStatus,
    }: any) =>
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        allOrders({
          reportName,
          reportParams,
          appendData,
          level,
          products,
          accountStatus,
        }),
      ),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    // @ts-expect-error TS(7030): Not all code paths return a value.
    fetchReport: (reportHeading: any) => {
      const {reportIsLoading} = stateProps;
      const {reportName, reportParams: [firstParam = {}, ...restParams] = []} =
        ownProps || {};
      if (!reportIsLoading) {
        return dispatchProps.fetchReport({
          reportName,
          level: getOrderReportLevel(reportHeading),
          products: 'all',
          accountStatus: 'all',
          reportParams: [
            {
              ...firstParam,
              [PAGE_SIZE_FIELD_NAME]: pageSize,
              [PAGE_NUMBER_FIELD_NAME]: 1,
            },
            ...restParams,
          ],
          appendData: false,
        });
      }
    },
    // @ts-expect-error TS(7030): Not all code paths return a value.
    fetchUpdatedReport: (_reportHeading: any) => {
      const {reportIsLoading} = stateProps;
      const {
        reportName,
        reportParams: [firstParam = {}, ...restParams] = [],
        filtersData,
      } = ownProps;

      if (!reportIsLoading) {
        return dispatchProps.fetchReport({
          reportName,
          level: filtersData.level,
          products: filtersData.products,
          accountStatus: filtersData.accountStatus,
          reportParams: [
            {
              ...firstParam,
              [PAGE_SIZE_FIELD_NAME]: pageSize,
              [PAGE_NUMBER_FIELD_NAME]: 1,
            },
            ...restParams,
          ],
          appendData: false,
        });
      }
    },
    // @ts-expect-error TS(7030): Not all code paths return a value.
    fetchMoreReport: (reportHeading: any) => {
      const {reportIsLoading, reportMeta} = stateProps;

      const {
        isEndReached,
        currentPage = 1,
        levelFilter,
        productsFilter,
        accountStatusFilter,
      } = reportMeta || {};

      const {reportName, reportParams: [firstParam = {}, ...restParams] = []} =
        ownProps;

      const numberOfRecords = size(stateProps.reportData);
      const total = reportMeta?.page?.total ?? 0;
      const nextPageNumber = calculatePageNumber({
        numberOfRecords,
        pageSize,
        total,
      });
      if (!nextPageNumber) return;
      if (nextPageNumber <= currentPage) return;

      if (!reportIsLoading && !isEndReached) {
        return dispatchProps.fetchReport({
          reportName,
          level: levelFilter ? levelFilter : getOrderReportLevel(reportHeading),
          products: productsFilter ? productsFilter : 'all',
          accountStatus: accountStatusFilter ? accountStatusFilter : 'all',
          reportParams: [
            {
              ...firstParam,
              [PAGE_SIZE_FIELD_NAME]: pageSize,
              [PAGE_NUMBER_FIELD_NAME]: nextPageNumber,
            },
            ...restParams,
          ],
          appendData: true,
        });
      }
    },
  }),
)(OrdersReportDataRenderer);
